export const checkLinkWithPadPrescription = padVisit => {
  const { padPrescriptions = [] } = padVisit;
  return Array.isArray(padPrescriptions) && padPrescriptions.length > 0;
};
